import { useEditEntityDrawer, UseEditEntityDrawerReturnType } from '../UseEditEntityDrawer';

export enum GuestSide {
  MEMBER = 'member',
  GUEST = 'guest',
}

export type DeleteDialogState = {
  isOpen: boolean;
  order?: any;
  onSubmitCallback?: () => void;
  event?: any;
  unavailability?: any;
  note?: any;
  shift?: any;
  guestSide?: GuestSide;
  guestCounterpartyName?: string;
};

export const useDeleteDialog = (): UseEditEntityDrawerReturnType<DeleteDialogState> => {
  return useEditEntityDrawer<DeleteDialogState>({ isOpen: false });
};
